import logo from '../../assets/images/new-logo.png'
import newLogin from '../../assets/images/new-login.svg'
import vr from '../../assets/images/video.mp4'
import './login.style.css'
import { LoginForm } from '../../components/loginForm/loginForm.component'

export const LoginPage = () => {
    return (
        <div className="vertical-layout vertical-menu-modern navbar-floating footer-static menu-collapsed"
            data-menu="vertical-menu-modern">
            <video className='bg'
                src={vr}
                autoPlay
                loop
                playsInline
                muted
            />
            <div className="app-content content login-p m-0 mr-lg-100">
                <div className="content-overlay" />
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-lg-2">
                                <img src={logo} alt="img" />
                            </div>
                            <div className="col-lg-7">
                                <img
                                    src={newLogin}
                                    alt="img"
                                    className="position-fixed h-100 snoi"
                                />
                            </div>
                            <LoginForm />
                        </div>
                    </div>
                </div>
            </div>
            <div className="sidenav-overlay" />
            <div className="drag-target" />
            <button className="btn btn-primary btn-icon scroll-top" type="button">
                <i className="fas fa-arrow-up" />
            </button>

        </div>
    )
}